import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, PageHeader, Space } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/constants/routes'

type Props = {
  name: string
}

const DetergentHistoriesPageHeader = ({}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Space>
      <Button onClick={() => navigate(routes.detergents.path)} icon={<ArrowLeftOutlined />}></Button>
      <PageHeader ghost={false} title={t('components.pages.detergentHistories.list.pageHeader.detergentTitle')} />
    </Space>
  )
}

DetergentHistoriesPageHeader.displayName = 'DetergentHistoriesPageHeader'
export default DetergentHistoriesPageHeader
